/* oxlint-disable react/no-unstable-nested-components -- LINTER migration follow up */
import { ButtonTypographyProvider } from "@grafit/design-system/components/molecules/button-typography";
import { Toaster } from "@grafit/design-system/components/molecules/toast";
import { EnvironmentRibbon } from "@grafit/design-system/components/organisms/environment-ribbon";
import { ErrorBoundary } from "@grafit/shared/observability/sentry-front";
import React from "react";
import { useFeatureFlag } from "../utils/feature-flags";
import { GlobalStatusBanner } from "./global-status-banner";
import { RootErrorFallbackWithAuth } from "./root-error-fallback";
import { Outlet } from "./router-api";

export function RootComponent() {
  const isTanstackDevtoolsEnabled = useFeatureFlag("tanstack-devtools");
  const isTypographyV2ButtonsEnabled = useFeatureFlag("typography-v2-buttons");

  return (
    <ButtonTypographyProvider value={isTypographyV2ButtonsEnabled ? "v2" : "v1"}>
      <ErrorBoundary fallback={({ error }) => <RootErrorFallbackWithAuth error={error} />} handled={false}>
        <GlobalStatusBanner />
        <Outlet />
        <EnvironmentRibbon />

        <Toaster />

        {import.meta.env.DEV && isTanstackDevtoolsEnabled && <TanStackDevtoolsLazy />}
      </ErrorBoundary>
    </ButtonTypographyProvider>
  );
}

const TanStackDevtoolsLazy = React.lazy(async () => {
  const [{ TanStackDevtools }, { TanStackRouterDevtoolsPanel }, { ReactQueryDevtoolsPanel }] = await Promise.all([
    import("@tanstack/react-devtools"),
    import("@tanstack/react-router-devtools"),
    import("@tanstack/react-query-devtools"),
  ]);

  return {
    default: () => (
      <TanStackDevtools
        config={{ openHotkey: [] }}
        plugins={[
          { name: "TanStack Query", render: <ReactQueryDevtoolsPanel /> },
          { name: "TanStack Router", render: <TanStackRouterDevtoolsPanel /> },
        ]}
      />
    ),
  };
});
